import * as actionTypes from "./ReportsType";

const INITIAL_STATE = {
    reportsList: [],
    moduleList: [],
    paramList: [],
    reportOutput: null,
    accessList: [],
    superUser: [],
    emailContent: null
};

const ReportsReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case actionTypes.SETREPORTSLIST:
            return {
                ...state,
                reportsList: action.payload.list,
            };
        case actionTypes.SETMODULELIST:
            return {
                ...state,
                moduleList: action.payload.list,
            };
        case actionTypes.SETPARAMLIST:
            return {
                ...state,
                paramList: action.payload.list,
            };
        case actionTypes.SETREPORTOUTPUT:
            return {
                ...state,
                reportOutput: action.payload.list,
            };
        case actionTypes.SETACCESSLIST:
            return {
                ...state,
                accessList: action.payload.list,
            };
        case actionTypes.SETSUPERUSER:
            return {
                ...state,
                superUser: action.payload.list,
            };
        case actionTypes.SETCONTENT:
            return {
                ...state,
                emailContent: action.payload.data,
            };
        default:
            return state;
    }
}

export default ReportsReducer;